import { Container } from 'inversify-props';
import setupStatus from './status/setup';

export default function setupPermissions(container: Container) {
  setupStatus(container);
}
